import React from "react";
import { ThumbsUp } from "lucide-react";

/**
 * Pin/thumbs-up button. Highlights when this model is the pinned "best answer" for the current search.
 */
export default function PinButton({ pinned, disabled, onToggle, modelId }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-label={pinned ? "Unpin as best answer" : "Pin as best answer"}
      title={pinned ? "Unpin" : "Pin as best answer"}
      className={`btn-ghost !h-8 !px-3 focus-ring disabled:opacity-30 ${
        pinned ? "!border-[#F5C542]/60 !text-[#F5C542] !bg-[#F5C542]/[0.08]" : ""
      }`}
      data-testid={`pin-${modelId}`}
      data-pinned={pinned ? "true" : "false"}
    >
      <ThumbsUp className={`w-3.5 h-3.5 ${pinned ? "fill-current" : ""}`} />
      <span className="text-[11px]">{pinned ? "Best" : "Pin"}</span>
    </button>
  );
}
